import { HandleParamChangeType } from '@/layers/presentation/hooks';
import { PatientParam, PatientParamValues } from '@/types/models';
import { Skeleton } from '@nextui-org/react';
import PatientParamsField from './PatientParamsField';

const LOG_MODULE = 'FE [Presentation / Components / PatientParamsForm]';

interface PatientParamsFormProps {
  mode: 'filter' | 'profile' | 'programRequest';
  patientParamsDictionary: PatientParam[];
  selectedOptions: PatientParamValues;
  onParamChange: HandleParamChangeType;
  isHideGenderAndAge?: boolean;
  isLoading: boolean;
  isDisabled?: boolean;
}

export default function PatientParamsForm({
  mode,
  patientParamsDictionary,
  selectedOptions,
  onParamChange,
  isLoading,
  isDisabled = false,
  isHideGenderAndAge = false,
}: PatientParamsFormProps) {
  const showFieldBySlug = (slug: string, isDisabled: boolean) => {
    const param = patientParamsDictionary.find(param => param.slug === slug);
    if (!param) {
      return null;
    }

    return (
      <PatientParamsField
        mode={mode}
        param={param}
        selectedOptions={selectedOptions}
        onParamChange={onParamChange}
        patientParamsDictionary={patientParamsDictionary}
        isDisabled={isDisabled}
        parentSelected={true}
      />
    );
  };

  return (
    <div className="space-y-8">
      {isLoading ? (
        <div className="grid grid-cols-2 gap-4">
          {Array.from({ length: 2 }).map((_, index) => (
            <Skeleton key={index} className="w-full h-14 rounded-2xl" />
          ))}
        </div>
      ) : (
        <div className="flex flex-col gap-4">
          <div className="flex flex-col md:flex-row gap-4">
            {showFieldBySlug('c3_cancer_type', isDisabled)}
            {showFieldBySlug('c3_cancer_subtype', isDisabled)}
          </div>
          <div className="flex flex-col md:flex-row gap-4 w-full">
            <div className="flex flex-row gap-4 w-full">
              {showFieldBySlug('gender', isDisabled)}
              {showFieldBySlug('age', isDisabled)}
            </div>
            <div className="flex flex-row gap-4 w-full">
              {showFieldBySlug('postal_code', isDisabled)}
              {showFieldBySlug('max_distance', isDisabled)}
            </div>
          </div>
          {showFieldBySlug('additional_info', isDisabled)}
        </div>
      )}
    </div>
  );
}
